import { render, staticRenderFns } from "./monitoring3PrintLable.vue?vue&type=template&id=511b96f2"
import script from "./monitoring3PrintLable.vue?vue&type=script&lang=js"
export * from "./monitoring3PrintLable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports